import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './DecorAtelier.css';

const DecorAtelier = () => {
  const services = [
    'Decoration',
    'Woodcraft and Carpenter work',
    'Backdrop frames',
    'Balloon Decoration',
    'Stage Layout',
    'Fabrication design',
    '3D Event Setup',
    'Theme Decoration',
  ];

  const themeOptions = [
    'Rainbow Celebration',
    'Colour Based Theme',
    'Carnival Party',
    'Jungle Theme',
    'Vintage Theme',
    'Farm Theme',
    'Beach Theme',
    'Green Garden Theme',
    'Eco-Friendly Decor',
    'Fairytale Theme',
    'Bollywood Theme',
    'Western Theme',
    'Royal Wedding Theme',
    'Lucknowi Theme',
    'Rajasthani Theme',
  ];

  return (
    <div className="decor-atelier-page">
      <PageBanner
        title="Decor Atelier"
        image={productionRouteBanners['decor-atelier']}
        imageAlt={productionRouteBannerAlts['decor-atelier']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Decoration Services</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Transform any space into a magical setting with our creative decoration services
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <h3>{service}</h3>
              </div>
            ))}
          </div>

          <div className="theme-section">
            <h2 className="section-title">Theme Decoration Options</h2>
            <div className="theme-grid">
              {themeOptions.map((theme, index) => (
                <div key={index} className="theme-card">
                  <span>{theme}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DecorAtelier;
